import { BLOCKS } from '@contentful/rich-text-types';
import { format } from 'date-fns';

import { newsSlugs } from '@boss/constants/corporate-jobs';
import { RichText } from '@boss/rich-text';
import { NewsArticleFields } from '@boss/types/corporate-jobs';

import { mapContentfulToNextLocale } from '../../utils/localeMapper';
import ComponentMapper from '../ComponentMapper';

const getNewsArticleProps = (entry: NewsArticleFields, locale: string) => {
  const { id, slug, image, title, publicationDate, metaDescription } = entry;

  return {
    annotation: publicationDate ? format(publicationDate, 'dd-MM-yyyy') : '',
    description: metaDescription,
    id,
    image: {
      id: image.id,
      imageUrl: image?.image?.file?.url,
      imageAlt: image?.image?.title,
    },
    link: `${newsSlugs[mapContentfulToNextLocale(locale)]}/${slug}`,
    title: title ? (
      <RichText
        ComponentMapper={ComponentMapper}
        content={title}
        mapperOptions={{ locale }}
        renderNode={{
          [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
        }}
        renderOptions={{ noWrapper: true }}
      />
    ) : null,
  };
};

export default getNewsArticleProps;
